import { Modal } from "react-bootstrap";
import BuildingNameList from "containers/property/BuildingNameList";

function BuildingNameModal({
    isAuthenticated,
    user,
    show,
    onClose,
    filter,
    data,
    updateTableState,
    saveRecord,
    deleteRecord,
    validateRelatedRecord,
}) {

    return (
        <Modal show={show} onHide={onClose} dialogClassName="property-table-modal-wide">
            <Modal.Header closeButton>
                <Modal.Title>Building Names</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BuildingNameList
                    filter={filter}
                    isAuthenticated={isAuthenticated}
                    isLoading={false}
                    controlType="table"
                    data={data}
                    user={user}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    deleteRecord={deleteRecord}
                />
            </Modal.Body>
        </Modal>
    );
}
export default BuildingNameModal;